/**
 *
 * @param {string} valueToValidate
 * @returns
 */
export default function (valueToValidate) {
    const isString = typeof valueToValidate === 'string'
    const isValid = isString ? !!(valueToValidate.length > 0) : false
    return isValid
}
